var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "my-info-browsinghistory" }, [
    _c("div", { staticClass: "f-nav" }, [
      _c("div", { class: ["nav", _vm.changeType == "r" ? "active-nav" : ""] }, [
        _c(
          "div",
          {
            staticClass: "nav-block",
            on: {
              click: function ($event) {
                return _vm.change_type("r")
              },
            },
          },
          [
            _c("div", [_vm._v("二手")]),
            _vm._v(" "),
            _c("div", {
              class: [
                "nav",
                _vm.changeType == "r" ? "change-line-active" : "change-line",
              ],
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          class: ["nav", _vm.changeType == "z" ? "active-nav" : ""],
          on: {
            click: function ($event) {
              return _vm.change_type("z")
            },
          },
        },
        [
          _c("div", { staticClass: "nav-block" }, [
            _c("div", [_vm._v("租房")]),
            _vm._v(" "),
            _c("div", {
              class: [
                "nav",
                _vm.changeType == "z" ? "change-line-active" : "change-line",
              ],
            }),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: ["nav", _vm.changeType == "x" ? "active-nav" : ""],
          on: {
            click: function ($event) {
              return _vm.change_type("x")
            },
          },
        },
        [
          _c("div", { staticClass: "nav-block" }, [
            _c("div", [_vm._v("新房")]),
            _vm._v(" "),
            _c("div", {
              class: [
                "nav",
                _vm.changeType == "x" ? "change-line-active" : "change-line",
              ],
            }),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", [
      _c(
        "div",
        { staticClass: "wrapper" },
        _vm._l(_vm.list, function (house, index) {
          return _c("house-item", {
            key: index,
            attrs: { house: house, type: "2" },
            on: { handleHosue: _vm.handleHosue },
          })
        }),
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.changeType == "r" && _vm.show_selectedType,
            expression: "changeType == 'r' && show_selectedType",
          },
        ],
        staticClass: "browse-menu",
      },
      [
        _c("div", { staticClass: "f-nav" }, [
          _c(
            "div",
            { class: ["nav", _vm.changeType == "l" ? "active-nav" : ""] },
            [
              _c(
                "div",
                {
                  staticClass: "nav-block",
                  on: {
                    click: function ($event) {
                      return _vm.change_type("l")
                    },
                  },
                },
                [_vm._m(0)]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class: ["nav", _vm.changeType == "s" ? "active-nav" : ""],
              on: {
                click: function ($event) {
                  return _vm.change_type("s")
                },
              },
            },
            [_vm._m(1)]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "change-type" }, [
          _c(
            "div",
            {
              class: [
                "tag",
                _vm.liu_selected == "ershoufan" ? "active-tag" : "",
              ],
              on: {
                click: function ($event) {
                  return _vm.selectType("ershoufan")
                },
              },
            },
            [_c("div", [_vm._v("全部")]), _vm._v(" "), _vm._m(2)]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class: ["tag", _vm.liu_selected == "zufan" ? "active-tag" : ""],
              on: {
                click: function ($event) {
                  return _vm.selectType("zufan")
                },
              },
            },
            [_c("div", [_vm._v("待看房")]), _vm._v(" "), _vm._m(3)]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class: ["tag", _vm.liu_selected == "xinfan" ? "active-tag" : ""],
              on: {
                click: function ($event) {
                  return _vm.selectType("xinfan")
                },
              },
            },
            [_c("div", [_vm._v("已看房")]), _vm._v(" "), _vm._m(4)]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class: ["tag", _vm.liu_selected == "xinfan" ? "active-tag" : ""],
              on: {
                click: function ($event) {
                  return _vm.selectType("xinfan")
                },
              },
            },
            [_c("div", [_vm._v("已取消")]), _vm._v(" "), _vm._m(5)]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "nav-block-arrow" }, [
      _c("div", [_vm._v("实地看房")]),
      _vm._v(" "),
      _c("div", { staticClass: "arrow-bottom" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "nav-block" }, [
      _c("div", [_vm._v("VR看房")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "show-active-tag", staticStyle: { display: "none" } },
      [
        _c("img", {
          staticClass: "selected-icon",
          attrs: { src: require("../../images/icon/selected.png"), alt: "" },
        }),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "show-active-tag", staticStyle: { display: "none" } },
      [
        _c("img", {
          staticClass: "selected-icon",
          attrs: { src: require("../../images/icon/selected.png"), alt: "" },
        }),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "show-active-tag", staticStyle: { display: "none" } },
      [
        _c("img", {
          staticClass: "selected-icon",
          attrs: { src: require("../../images/icon/selected.png"), alt: "" },
        }),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "show-active-tag", staticStyle: { display: "none" } },
      [
        _c("img", {
          staticClass: "selected-icon",
          attrs: { src: require("../../images/icon/selected.png"), alt: "" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }